// ToastContext.tsx
import { createSignal, For, createContext, useContext, JSX } from "solid-js";

type Toast = {
	message: string;
	style: string;
};

type ToastContextValue = {
	addToast: ( msg: string, style: string ) => void;
	toastTypes: typeof toastTypes;
};

enum toastTypes {
	success = 'success',
	error = 'error',
}

export const ToastContext = createContext<ToastContextValue>();

export const useToast = (): ToastContextValue => useContext( ToastContext ) as ToastContextValue;

export const ToastProvider = ( props: { children: JSX.Element } ) => {
	const [toasts, setToasts] = createSignal<Toast[]>( [] );

	const addToast = ( msg: string, style: string, timeout:number = 7500 ) => {
		setToasts( [...toasts(), { message: msg, style }] );
		setTimeout( () => {
			setToasts( toasts().slice( 1 ) );
		}, timeout );
	}

	return (
		<ToastContext.Provider value={{ addToast, toastTypes }}>
			<div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6">
				<div class="flex w-full flex-col items-center space-y-4 sm:items-end">
					<For each={toasts()}>
						{t =>
							<div class="pointer-events-auto w-full max-w-sm translate-y-0 transform rounded-lg opacity-100 shadow-lg outline-1 outline-black/5 transition duration-300 ease-out sm:translate-x-0 starting:translate-y-2 starting:opacity-0 starting:sm:translate-x-2 starting:sm:translate-y-0 p-4"
								classList={{ "bg-white": t.style == 'success', "bg-red-100": t.style == 'error', }}>
								<div class="flex items-start">
									<div class="shrink-0">
										<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6"
											classList={{ "text-green-400": t.style == 'success', "text-red-400": t.style == 'error', }}>
											<path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
									</div>
									<div class="ml-3 w-0 flex-1">
										<span class="block my-0 text-sm font-medium text-gray-900 capitalize">{t.style}</span>
										<span class="block mt-1 text-sm text-gray-500">{t.message}</span>
									</div>
									{/*
										<div class="ml-4 flex shrink-0">
											<button type="button" class="inline-flex rounded-md text-gray-400 hover:text-gray-500 focus:outline-2 focus:outline-offset-2 focus:outline-sky-600">
												<span class="sr-only">Close</span>
												<svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
													<path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
												</svg>
											</button>
										</div>
										*/}
								</div>
							</div>
						}
					</For>
				</div>
			</div>

			{props.children}
		</ToastContext.Provider>
	);
};

